import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useUserStore } from '@/stores/user';

export const useRegisterStore = defineStore('register', () => {
  const { hasFeatureFlag } = useUserStore();
  const cashupEnabled = computed(() => !!hasFeatureFlag('beta-cashup'));

  const showOpenDrawerModal = ref(false);
  const showCannotSaveOutstandingModal = ref(false);
  const savingDraft = ref(false);
  const savingOrder = ref(false);
  const isEditing = ref(false);
  const isPaying = ref(false);

  const exitCurrentState = () => {
    isEditing.value = false;
    isPaying.value = false;
  };

  return {
    cashupEnabled,
    showOpenDrawerModal,
    savingDraft,
    savingOrder,
    showCannotSaveOutstandingModal,
    isEditing,
    isPaying,
    exitCurrentState,
  };
});
